const bodySizeOptions = ['xsmall', 'small', 'medium', 'large'];
const headingSizeOptions = [
    'xxxsmall',
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'xxxlarge',
];
const displaySizeOptions = [
    'xxxxxsmall',
    'xxxxsmall',
    'xxxsmall',
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'xxxlarge',
];
const weightOptions = ['light', 'regular', 'medium', 'bold'];
const displayWeightOptions = ['semibold', 'bold'];
const bodyTransformOptions = ['caption', 'underline'];
const headingTransformOptions = ['underline'];
const displayTransformOptions = ['uppercase', 'underline'];

export { bodySizeOptions, bodyTransformOptions, displaySizeOptions, displayTransformOptions, displayWeightOptions, headingSizeOptions, headingTransformOptions, weightOptions };
//# sourceMappingURL=constants.js.map
